import { useQuery } from "react-query";

import { getClinicianHours } from "api/clinician";
import { GET_CLINICIAN_HOURS, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { queryParamsObjIsValid } from "utils/queryParamsObjIsValid";

/**
 * `useClinicianGetHours` is a hook that fetches a clinician's hours using a GET request to
 * `/v3/clinician/[clinicianId]/hours` endpoint.
 * @param {string} clinicianId - The clinician id
 * @param {Object} query - The query object
 * @returns {Object} The hours data
 */
const useClinicianGetHours = (clinicianId, query = {}) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_CLINICIAN_HOURS, clinicianId, query],
    () => getClinicianHours(clinicianId, query),
    {
      refetchOnWindowFocus: false,
      enabled: clinicianId && queryParamsObjIsValid(query),
      staleTime: STALE_TIME_5_MINUTES,
    }
  );

  return { hours: data?.data || null, isHoursLoading: isLoading, ...rest };
};

export default useClinicianGetHours;
